import { BannerId } from '../../../typings/banners';

export const SAVE_INTERNAL_BANNER_NAME_EDITOR_CHANGES = 'SAVE_INTERNAL_BANNER_NAME_EDITOR_CHANGES';
export type SAVE_INTERNAL_BANNER_NAME_EDITOR_CHANGES = typeof SAVE_INTERNAL_BANNER_NAME_EDITOR_CHANGES;

export interface SaveInternalBannerNameEditorChanges {
    type: SAVE_INTERNAL_BANNER_NAME_EDITOR_CHANGES;
    bannerId: BannerId;
}

export function saveInternalBannerNameEditorChangesAction(bannerId: BannerId): SaveInternalBannerNameEditorChanges {
    return {
        type: SAVE_INTERNAL_BANNER_NAME_EDITOR_CHANGES,
        bannerId
    };
}
